export const RESTAURANT_ID = 'kadihan';
